import type { UserSuccessPathway } from "@/lib/server/models/user"
import classifiedsData from "@/lib/copy/pathways/classifieds"
import googleMyBusinessData from "@/lib/copy/pathways/googleMyBusiness"
import zillowData from "@/lib/copy/pathways/zillow"

export type UserPathwayItem = {
  title: string
  info?: string
  videoUrl?: string
  id: string
} 

export type UserPathwayPage = {
  title: string
  items: UserPathwayItem[]
  id: string
}

export function usePathwayData(
  pathway: UserSuccessPathway | (string & {})
): UserPathwayPage[] | null {
  switch (pathway) {
    case "classifieds":
      return classifiedsData
    case "googlebiz":
      return googleMyBusinessData
    case "zillowhack":
      return zillowData
    default:
      return null
  }
}